import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import UserForm from '../user-form';
import Text from '../shared/Typography';
import UserFormModel from '../../models/ProfileForm';
import authApiService from '../../services/auth-api-service';
import AuthLayout from '../layouts/AuthLayout';
import { SignUpAppBanner } from '../shared/native-app-banner';
import Card from '../shared/Card';
import { getRouteTFunction } from '../../i18n';
import userActions from '../../actions/user';

type Props = {
  history: History,
  noRedirect: ?boolean,
  callBack: ?any
} & WithTranslation;

class UserCreate extends Component<Props> {
  props: Props;

  constructor(props) {
    super(props);
    this.state = {
      user: new UserFormModel(),
      loading: false
    };
  }

  componentDidMount() {
    if (!this.props.user) {
      this.props.fetchUser(['onboarding_state', 'address', 'region']);
    }
  }

  updateUser(name: string, value: ?string): void {
    const newUser = new UserFormModel(
      Object.assign({}, this.state.user.values, {
        [name]: value
      })
    );
    this.setState({
      user: newUser
    });
  }

  userValueChange = (name: string, value: string): void => {
    this.updateUser(name, value);
  };

  userFormSubmit = (evt: Event): void => {
    evt.preventDefault();
    this.setState({ loading: true });
    this.state.user.validate(this.props.hasRegion ? ['first_name', 'last_name', 'dob'] : ['region_id']);
    if (this.state.user.hasErrors) {
      this.setState({
        loading: false
      });
    } else if (!this.props.hasRegion) {
      const submissionUser = { user: { region_id: this.state.user.values.region_id } };
      this.props.updateUser(submissionUser);
      this.setState({
        loading: false
      });
    } else {
      const routesTFunction = getRouteTFunction();
      authApiService
        .post('/onboarding/create_profile', { user: this.state.user.values })
        .then(() => {
          if (this.props.callBack) {
            this.props.callBack();
          } else {
            this.props.history.push(routesTFunction('redirectPaths./dashboard'));
          }
        })
        .catch((error) => {
          this.setState({
            error,
            loading: false
          });
        });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <AuthLayout className='signup'>
        <div className='auth-page__form'>
          <div className='auth-tabs'>
            <div className='auth-tabs__tab is-active'>{t('create_account')}</div>
            {/* <Link className='auth-tabs__tab' to='/login'>Log in to your account</Link> */}
          </div>
          <div className='auth-page__header'>
            {this.props.hasRegion ? (
              <React.Fragment>
                <Text h1>{t('set_profile')}</Text>
                <Text paragraph>{t('set_profile_msg')}</Text>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Text h1>{t('set_region')}</Text>
                <Text paragraph>{t('set_region_msg')}</Text>
              </React.Fragment>
            )}
          </div>
          <UserForm
            user={this.state.user.values}
            errors={this.state.user.errors}
            onSubmit={this.userFormSubmit}
            onValueChange={this.userValueChange}
            cta={t('continue')}
            isLoading={this.state.loading}
            successMsg={this.state.profileMessage}
            hideInsuranceField
            hidePhoneField
            hideRegionField={this.props.hasRegion}
            onlyShowRegionField={!this.props.hasRegion}
          />
          <Text paragraph id='flash' className='is-error'>
            {this.state.error}
          </Text>
        </div>
        <div className='auth-page__info'>
          <Card className='auth-page__card' noShadow noPadding>
            <div className='auth-page__card__body'>
              <SignUpAppBanner />
            </div>
          </Card>
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return { user: state.user.data, hasRegion: state.user.data && state.user.data.region };
};

export default withTranslation('userCreate')(
  connect(mapStateToProps, { fetchUser: userActions.fetchUser, updateUser: userActions.updateUser })(UserCreate)
);



// WEBPACK FOOTER //
// ./src/components/pages/user-create.js